import { Box, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { tabItemSx } from '../../../Service/components/AdminTables/consts/table.styles'
import {
  adminServiceTabStore,
  RequestsTabType,
} from '../../../Service/components/AdminTables/stores/AdminServiceTablesStore'
import DealerTabbedTableView from './DealerTabbedTableView'
import {
  resetAllAdminFiltersAndPagination,
  tabComponents,
} from './consts/table-stores.data'

export const tabs: RequestsTabType[] = [
  'все заявки',
  'назначены',
  'приняты',
  'в работе',
  'установка',
  'установленные',
  'не выполненные',
]

const DealerAllRequestsTables = () => {
  const { requestsTab, setRequestsTab } = adminServiceTabStore

  const onTabChange = (tabItem: RequestsTabType) => {
    setRequestsTab(tabItem)
    resetAllAdminFiltersAndPagination()
  }

  useEffect(() => {
    resetAllAdminFiltersAndPagination()
  }, [])

  return (
    <Stack gap={'16px'}>
      <Stack direction={'row'} gap={'4px'}>
        {tabs.map((tabItem) => (
          <Box
            sx={tabItemSx(tabItem === requestsTab)}
            key={tabItem}
            onClick={() => onTabChange(tabItem)}
          >
            {tabItem}
          </Box>
        ))}
      </Stack>
      {Object.entries(tabComponents).map(
        ([tabName, stores]) =>
          requestsTab === tabName && (
            <DealerTabbedTableView
              key={tabName}
              paginationStore={stores.paginationStore}
              tab={tabName}
              filtersStore={stores.filtersStore}
              checkboxStore={stores.checkboxStore}
            />
          ),
      )}
    </Stack>
  )
}

export default observer(DealerAllRequestsTables)
